
    import './styles.scoped.css';
    export default {
  "column-layout": "awsui_column-layout_vj6p7_l6qtz_3",
  "grid": "awsui_grid_vj6p7_l6qtz_13",
  "grid-no-gutters": "awsui_grid-no-gutters_vj6p7_l6qtz_18",
  "grid-variant-text-grid": "awsui_grid-variant-text-grid_vj6p7_l6qtz_21",
  "grid-breakpoint-default": "awsui_grid-breakpoint-default_vj6p7_l6qtz_28",
  "grid-columns-1": "awsui_grid-columns-1_vj6p7_l6qtz_31",
  "grid-breakpoint-xxs": "awsui_grid-breakpoint-xxs_vj6p7_l6qtz_31",
  "grid-breakpoint-xs": "awsui_grid-breakpoint-xs_vj6p7_l6qtz_34",
  "grid-columns-2": "awsui_grid-columns-2_vj6p7_l6qtz_37",
  "grid-columns-3": "awsui_grid-columns-3_vj6p7_l6qtz_43",
  "grid-columns-4": "awsui_grid-columns-4_vj6p7_l6qtz_49",
  "grid-vertical-borders": "awsui_grid-vertical-borders_vj6p7_l6qtz_62",
  "grid-horizontal-borders": "awsui_grid-horizontal-borders_vj6p7_l6qtz_95",
  "root": "awsui_root_vj6p7_l6qtz_145",
  "tile-container": "awsui_tile-container_vj6p7_l6qtz_159",
  "has-metadata": "awsui_has-metadata_vj6p7_l6qtz_168",
  "selected": "awsui_selected_vj6p7_l6qtz_171",
  "disabled": "awsui_disabled_vj6p7_l6qtz_175",
  "columns": "awsui_columns_vj6p7_l6qtz_190",
  "column-1": "awsui_column-1_vj6p7_l6qtz_195",
  "breakpoint-xs": "awsui_breakpoint-xs_vj6p7_l6qtz_202",
  "breakpoint-xxs": "awsui_breakpoint-xxs_vj6p7_l6qtz_207",
  "column-2": "awsui_column-2_vj6p7_l6qtz_212",
  "column-3": "awsui_column-3_vj6p7_l6qtz_229",
  "column-4": "awsui_column-4_vj6p7_l6qtz_246",
  "control": "awsui_control_vj6p7_l6qtz_264",
  "no-image": "awsui_no-image_vj6p7_l6qtz_268",
  "image": "awsui_image_vj6p7_l6qtz_272"
};
  